/* eslint-disable @angular-eslint/component-selector */
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { EmptyComponent } from '../empty/empty.component';

@Component({
  selector: 'error-state',
  imports: [MatIconModule, MatButton, TranslocoDirective, EmptyComponent],
  templateUrl: './error-state.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorStateComponent {
  message = input.required<string>();
  icon = input<string>();

  retry = output<void>();

  onRetry(): void {
    this.retry.emit();
  }
}
